import React from 'react';

import { ScrollView } from '@rbilabs/universal-components';

import { MarketingTileSkeleton } from 'components/marketing-tile/marketing-tile.skeleton';
import { HeroSkeleton } from 'components/ucl/hero/hero.skeleton';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';

export const HomePageSkeleton = React.memo(() => {
  const isDesktop = useIsDesktopBreakpoint();

  return (
    <ScrollView contentContainerStyle={{ alignSelf: isDesktop ? 'center' : undefined }}>
      <HeroSkeleton />
      <MarketingTileSkeleton />
    </ScrollView>
  );
});
